export default __webpack_public_path__ + "static/media/projectSpray.848d4bd8.bin";